module.exports = __webpack_public_path__ + "img/security.2ea1930a.svg";